import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=1eff98ce&scoped=true"
import script from "./groupList.vue?vue&type=script&lang=js"
export * from "./groupList.vue?vue&type=script&lang=js"
import style0 from "./groupList.vue?vue&type=style&index=0&id=1eff98ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff98ce",
  null
  
)

export default component.exports